<script>
export default {
  name: 'NoteModal',
  props: {
    visible: Boolean,
    note: String,
  },
  methods: {
    closeModal() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<template>
  <b-modal :visible="visible" title="Note Detail" @hidden="closeModal" ok-only>
    <p style="white-space: pre-wrap;">{{ note }}</p>
  </b-modal>
</template>
